import type { DefaultOptionType } from 'antd/es/select';

import type { CustomerEquipmentTypesResponse } from './api';

export const normalizeCustomerEquipmentTypes = (list: CustomerEquipmentTypesResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.description,
    value: row.trailerKey,
  }));
};
